import { CoreLogService } from "../log.service";
import { Lifecycletrigger, LifecycletriggerDefault } from "./comEnvironmentTriggerLifecycletrigger"

/** Trigger für Plattformevents */

export interface Trigger {
  lifecycleTrigger: Lifecycletrigger;
}

/** Standardimplementierung */
export class TriggerDefault implements Trigger {

  private _lifecycleTrigger: Lifecycletrigger;

  /** Trigger für Plattformevents */
  constructor(private _coreLogService: CoreLogService) {
    this._setLifecycletrigger(new LifecycletriggerDefault(_coreLogService));
  }

  public get lifecycleTrigger(): Lifecycletrigger {
    return this._lifecycleTrigger;
  }

  private _setLifecycletrigger(value: Lifecycletrigger) {
    this._lifecycleTrigger = value;
  }
}
